export default __webpack_public_path__ + "static/media/menCoatWest.f30f086f.png";